import { render, staticRenderFns, recyclableRender, components } from "./confirm-order.vue?vue&type=template&id=2f2cf9ec&scoped=true&"
var renderjs
import script from "./confirm-order.vue?vue&type=script&lang=js&"
export * from "./confirm-order.vue?vue&type=script&lang=js&"
import style0 from "./confirm-order.vue?vue&type=style&index=0&lang=css&"
import style1 from "./confirm-order.vue?vue&type=style&index=1&id=2f2cf9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2cf9ec",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/confirm-order/confirm-order.vue"
export default component.exports